import React from 'react';

const SeoSchema = (jsonLdCollection) => {
    const isValidCollection = jsonLdCollection && jsonLdCollection.items && jsonLdCollection.items.length > 0;

    if (!isValidCollection) {
        return null;
    }

    return jsonLdCollection.items.map((data, index) => {
        let jsonString;
        try {
            if (!data?.json || typeof data.json !== 'object') {
                console.warn(`Invalid JSON-LD data at index ${index}`);
                return null;
            }
            jsonString = JSON.stringify(data.json);
        } catch (error) {
            console.error(`Failed to stringify JSON-LD at index ${index}:`, error);
            return null;
        }

        return (
            <script key={index} type="application/ld+json">
                {jsonString}
            </script>
        );
    }).filter(Boolean);
};

export default SeoSchema;
